import { SimplePopoverOptionsType } from '@dev/ee-components';
import {
    ConditionOptionsInterface,
    OptionInterface,
    RuleFieldOptionsInterface,
    RuleValueOptionsInterface,
} from './SegmentRuleToolInterface';
import i18n from './../../../../i18n';

// TODO: TRANSLATE ALL LABELS

export const RuleValueOptions: RuleValueOptionsInterface = {
    Boolean: [
        {
            labelTranslated: i18n.t('segmentrulelabeltrue') as string,
            label: 'segmentrulelabeltrue',
            value: 'True',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelfalse') as string,
            label: 'segmentrulelabelfalse',
            value: 'False',
        },
    ],
    ConsentTracking: [
        {
            labelTranslated: i18n.t('segmentrulelabelunknown') as string,
            label: 'segmentrulelabelunknown',
            value: 'Unknown',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelallow') as string,
            label: 'segmentrulelabelallow',
            value: 'Allow',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldeny') as string,
            label: 'segmentrulelabeldeny',
            value: 'Deny',
        },
    ],
    UnsubscribeReason: [
        {
            labelTranslated: i18n.t('segmentrulelabelunknown') as string,
            label: 'segmentrulelabelunknown',
            value: 'Unknown',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelnolongerwishreceiveemails') as string,
            label: 'segmentrulelabelnolongerwishreceiveemails',
            value: 'I no longer wish to receive your emails',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelsendingtoofrequently') as string,
            label: 'segmentrulelabelsendingtoofrequently',
            value: 'You are sending too frequently',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelneveraskedreceive') as string,
            label: 'segmentrulelabelneveraskedreceive',
            value: 'I never asked to receive this email',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelcontainsdeceptivecontent') as string,
            label: 'segmentrulelabelcontainsdeceptivecontent',
            value: 'Email contains deceptive content',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelmarkedasjunkorspam') as string,
            label: 'segmentrulelabelmarkedasjunkorspam',
            value: 'Contact marked the email as junk or spam with their email provider',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelunsubscribedviathirdparty') as string,
            label: 'segmentrulelabelunsubscribedviathirdparty',
            value: 'Contact unsubscribed via a third-party unsubscribe system',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelunsubscribedvialistunsubscribe') as string,
            label: 'segmentrulelabelunsubscribedvialistunsubscribe',
            value: 'Contact unsubscribed via list-unsubscribe header',
        },
    ],
    Source: [
        {
            labelTranslated: i18n.t('segmentrulelabeldeliveryapi') as string,
            label: 'segmentrulelabeldeliveryapi',
            value: 'DeliveryApi',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelmanualinput') as string,
            label: 'segmentrulelabelmanualinput',
            value: 'ManualInput',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelfileupload') as string,
            label: 'segmentrulelabelfileupload',
            value: 'FileUpload',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelwebform') as string,
            label: 'segmentrulelabelwebform',
            value: 'WebForm',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelcontactapi') as string,
            label: 'segmentrulelabelcontactapi',
            value: 'ContactApi',
        },
    ],
    Status: [
        {
            labelTranslated: i18n.t('segmentrulelabeltransactional') as string,
            label: 'segmentrulelabeltransactional',
            value: 'Transactional',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelengaged') as string,
            label: 'segmentrulelabelengaged',
            value: 'Engaged',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelactive') as string,
            label: 'segmentrulelabelactive',
            value: 'Active',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelinactive') as string,
            label: 'segmentrulelabelinactive',
            value: 'Inactive',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelbounced') as string,
            label: 'segmentrulelabelbounced',
            value: 'Bounced',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelunsubscribed') as string,
            label: 'segmentrulelabelunsubscribed',
            value: 'Unsubscribed',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelabuse') as string,
            label: 'segmentrulelabelabuse',
            value: 'Abuse',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelstale') as string,
            label: 'segmentrulelabelstale',
            value: 'Stale',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelnotconfirmed') as string,
            label: 'segmentrulelabelnotconfirmed',
            value: 'NotConfirmed',
        },
    ],
};

export const ConditionOptions: ConditionOptionsInterface | SimplePopoverOptionsType = {
    String: [
        {
            labelTranslated: i18n.t('segmentrulelabelis') as string,
            label: 'segmentrulelabelis',
            value: '=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelisnot') as string,
            label: 'segmentrulelabelisnot',
            value: '!=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelstartswith') as string,
            label: 'segmentrulelabelstartswith',
            value: 'starts-with',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelendswith') as string,
            label: 'segmentrulelabelendswith',
            value: 'ends-with',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelcontains') as string,
            label: 'segmentrulelabelcontains',
            value: 'contains',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelnotcontains') as string,
            label: 'segmentrulelabelnotcontains',
            value: 'not-contains',
        },
    ],
    Number: [
        {
            labelTranslated: i18n.t('segmentrulelabelis') as string,
            label: 'segmentrulelabelis',
            value: '=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelisnot') as string,
            label: 'segmentrulelabelisnot',
            value: '!=',
        },
        {
            labelTranslated: '>',
            label: '>',
            value: '>',
        },
        {
            labelTranslated: '<',
            label: '<',
            value: '<',
        },
        {
            labelTranslated: '>=',
            label: '>=',
            value: '>=',
        },
        {
            labelTranslated: '<=',
            label: '<=',
            value: '<=',
        },
    ],
    Datetime: [
        {
            labelTranslated: i18n.t('segmentrulelabelis') as string,
            label: 'segmentrulelabelis',
            value: '=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelmonthdayonly') as string,
            label: 'segmentrulelabelmonthdayonly',
            value: 'month-day',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelisnot') as string,
            label: 'segmentrulelabelisnot',
            value: '!=',
        },
        {
            labelTranslated: '>',
            label: '>',
            value: '>',
        },
        {
            labelTranslated: '<',
            label: '<',
            value: '<',
        },
        {
            labelTranslated: '>=',
            label: '>=',
            value: '>=',
        },
        {
            labelTranslated: '<=',
            label: '<=',
            value: '<=',
        },
    ],
    Date: [
        {
            labelTranslated: i18n.t('segmentrulelabelis') as string,
            label: 'segmentrulelabelis',
            value: '=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelmonthdayonly') as string,
            label: 'segmentrulelabelmonthdayonly',
            value: 'month-day',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelisnot') as string,
            label: 'segmentrulelabelisnot',
            value: '!=',
        },
        {
            labelTranslated: '>',
            label: '>',
            value: '>',
        },
        {
            labelTranslated: '<',
            label: '<',
            value: '<',
        },
        {
            labelTranslated: '>=',
            label: '>=',
            value: '>=',
        },
        {
            labelTranslated: '<=',
            label: '<=',
            value: '<=',
        },
    ],
    Boolean: [
        {
            labelTranslated: i18n.t('segmentrulelabelis') as string,
            label: 'segmentrulelabelis',
            value: '=',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelisnot') as string,
            label: 'segmentrulelabelisnot',
            value: '!=',
        },
    ],
};

export const AndOrOptions: OptionInterface[] = [
    {
        labelTranslated: i18n.t('segmentrulelabeland') as string,
        label: 'segmentrulelabeland',
        value: 'AND',
    },
    {
        labelTranslated: i18n.t('segmentrulelabelor') as string,
        label: 'segmentrulelabelor',
        value: 'OR',
    },
];

export const RuleOptionsCategories = {
    segmentrulelabelgeneral: i18n.t('segmentrulelabelgeneral'),
    segmentrulelabelstatistics: i18n.t('segmentrulelabelstatistics'),
};

export const RuleFieldOptions: RuleFieldOptionsInterface = {
    segmentrulelabelgeneral: [
        {
            labelTranslated: i18n.t('segmentrulelabelfirstname') as string,
            label: 'segmentrulelabelfirstname',
            value: 'firstname',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellastname') as string,
            label: 'segmentrulelabellastname',
            value: 'lastname',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellistname') as string,
            label: 'segmentrulelabellistname',
            value: 'listname',
            ruleConditionType: 'boolean',
            ruleValueType: 'Listname',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelstatus') as string,
            label: 'segmentrulelabelstatus',
            value: 'status',
            ruleConditionType: 'boolean',
            ruleValueType: 'Status',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelsource') as string,
            label: 'segmentrulelabelsource',
            value: 'source',
            ruleConditionType: 'boolean',
            ruleValueType: 'Source',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelunsubscribereason') as string,
            label: 'segmentrulelabelunsubscribereason',
            value: 'unsubscribereason',
            ruleConditionType: 'boolean',
            ruleValueType: 'UnsubscribeReason',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelemail') as string,
            label: 'segmentrulelabelemail',
            value: 'email',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldateadded') as string,
            label: 'segmentrulelabeldateadded',
            value: 'dateadded',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldateupdated') as string,
            label: 'segmentrulelabeldateupdated',
            value: 'dateupdated',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelstatuschangedate') as string,
            label: 'segmentrulelabelstatuschangedate',
            value: 'statuschangedate',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelconsentdate') as string,
            label: 'segmentrulelabelconsentdate',
            value: 'consentdate',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelconsentip') as string,
            label: 'segmentrulelabelconsentip',
            value: 'consentip',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelconsenttracking') as string,
            label: 'segmentrulelabelconsenttracking',
            value: 'consenttracking',
            ruleConditionType: 'boolean',
            ruleValueType: 'ConsentTracking',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincedateadded') as string,
            label: 'segmentrulelabeldayssincedateadded',
            value: 'daysfromdateadded',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincedateupdated') as string,
            label: 'segmentrulelabeldayssincedateupdated',
            value: 'daysfromstatuschangedate',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssinceconsentdate') as string,
            label: 'segmentrulelabeldayssinceconsentdate',
            value: 'daysfromconsentdate',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabelcreatedfromip') as string,
            label: 'segmentrulelabelcreatedfromip',
            value: 'createdfromip',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellasterror') as string,
            label: 'segmentrulelabellasterror',
            value: 'friendlyerrormessage',
            ruleConditionType: 'text',
            ruleValueType: 'String',
        },
    ],
    segmentrulelabelstatistics: [
        {
            labelTranslated: i18n.t('segmentrulelabeltotalsent') as string,
            label: 'segmentrulelabeltotalsent',
            value: 'totalsent',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeltotalopens') as string,
            label: 'segmentrulelabeltotalopens',
            value: 'totalopened',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeltotalclicks') as string,
            label: 'segmentrulelabeltotalclicks',
            value: 'totalclicked',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeltotalbounces') as string,
            label: 'segmentrulelabeltotalbounces',
            value: 'totalfailed',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellastsent') as string,
            label: 'segmentrulelabellastsent',
            value: 'lastsent',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellastopened') as string,
            label: 'segmentrulelabellastopened',
            value: 'lastopened',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellastclicked') as string,
            label: 'segmentrulelabellastclicked',
            value: 'lastclicked',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabellastbounced') as string,
            label: 'segmentrulelabellastbounced',
            value: 'firstfaileddate',
            ruleConditionType: 'datetime',
            ruleValueType: 'Datetime',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincelastsent') as string,
            label: 'segmentrulelabeldayssincelastsent',
            value: 'daysfromlastsent',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincelastopened') as string,
            label: 'segmentrulelabeldayssincelastopened',
            value: 'daysfromlastopened',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincelastclicked') as string,
            label: 'segmentrulelabeldayssincelastclicked',
            value: 'daysfromlastclicked',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
        {
            labelTranslated: i18n.t('segmentrulelabeldayssincelastbounced') as string,
            label: 'segmentrulelabeldayssincelastbounced',
            value: 'daysfromlastfailed',
            ruleConditionType: 'number',
            ruleValueType: 'Number',
        },
    ],
};
